import React from 'react'
import CopyToClipboard from '../../../../utils/copy-to-clipboard'

const CardPrefix = ({ value }) => {
  return <CopyToClipboard text={value}>{value}</CopyToClipboard>
}
export default CardPrefix
